
import axios from 'axios'

const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }

const url = `${process.env.VUE_APP_GEONAMES_URL}`
const username = `${process.env.VUE_APP_GEONAMES_USERNAME}`
const withCredentials = false

export default class ForeignRegionService {
    static async postalCodeSearch (params = {}) {
        try {
            let { postalcode, country, maxRows } = params
            if (!postalcode || !country) throw new Error('Código postal y país son requeridos')
            if (!maxRows) maxRows = 10

            params.username = username

            let { data } = await axios.get(`${url}/postalCodeSearchJSON`, { headers, params, withCredentials })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async postalCodeLookup (params = {}) {
        try {
            let { postalcode, country, maxRows } = params
            if (!postalcode || !country) throw new Error('Código postal y país son requeridos')
            if (!maxRows) maxRows = 20

            params.username = username

            let { data } = await axios.get(`${url}/postalCodeLookupJSON`, { headers, params, withCredentials })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }
}
